import { NgModule, Pipe, PipeTransform } from '@angular/core';

export function userId(value: string): string {
  return (value || '').replace('i:0#.f|membership|', '').replace('@corpaa.aa.com', '');
}

@Pipe({
  name: 'userId'
})
export class UserIdPipe implements PipeTransform {

  transform(value: string): string {
    return userId(value);
  }

}

@NgModule({
  imports: [],
  declarations: [UserIdPipe],
  exports: [UserIdPipe]
})
export class UserIdPipeModule { }
